import { queryOptions } from "@tanstack/react-query";
import { purchasingApi } from "./api.ts";
import type { OrderFilter } from "./types.ts";

// Ключи закупок начинаются с "purchasing": после любого действия экран
// сбрасывает их разом, корзины, черновики и задачи не расходятся.
export const PURCHASING = ["purchasing"] as const;

export const basketsQuery = queryOptions({ queryKey: [...PURCHASING, "baskets"], queryFn: purchasingApi.baskets });
export const expectedQuery = queryOptions({ queryKey: [...PURCHASING, "expected"], queryFn: purchasingApi.expected });
export const frequentQuery = queryOptions({ queryKey: [...PURCHASING, "frequent"], queryFn: purchasingApi.frequent });
export const tasksQuery = queryOptions({ queryKey: [...PURCHASING, "tasks"], queryFn: purchasingApi.reconciliation });
export const suppliersQuery = queryOptions({ queryKey: [...PURCHASING, "suppliers"], queryFn: purchasingApi.suppliers, staleTime: 5 * 60_000 });

export const ordersQuery = (filters: OrderFilter[]) =>
  queryOptions({ queryKey: [...PURCHASING, "orders", ...filters], queryFn: () => purchasingApi.orders(filters) });

export const orderQuery = (id: string) =>
  queryOptions({ queryKey: [...PURCHASING, "order", id], queryFn: () => purchasingApi.order(id), retry: false });

export const adviceQuery = (warehouseId: string, productId: string) =>
  queryOptions({
    queryKey: [...PURCHASING, "advice", warehouseId, productId],
    queryFn: () => purchasingApi.advice(warehouseId, productId),
    staleTime: 60_000,
  });
